import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import Chart from 'chart.js/auto';

class MultiSeriesPieChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
    this.state = {
    };
  }

  componentDidMount() {
    this.drawChart();
  }

  componentDidUpdate(prevState) {
    const { activeIndex } = this.state;
    if (prevState.activeIndex !== activeIndex) {
      this.drawChart();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  drawChart() {
    const { chartData, translate } = this.props;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    const { matched_identifiers, unmatched_identifiers, ignored_identifiers } = chartData;
    let unique_identifiers;
    let others;

    const stringToNumber = (string) => {
      return parseFloat(string.replace(/,/g, ''));
    };

    if (stringToNumber(chartData.unique_identifiers) > stringToNumber(chartData.matched_identifiers)) {
      unique_identifiers = parseFloat(chartData.matched_identifiers);
      others = 0;
    } else {
      unique_identifiers = stringToNumber(chartData.unique_identifiers);
      others = stringToNumber(chartData.matched_identifiers) - stringToNumber(chartData.unique_identifiers);
    }

    const innerDataset = {
      labels: [translate('list.title.unique'), translate('list.title.others'), translate('list.title.Unmatched'), translate('list.title.ignored')],
      data: [unique_identifiers, others, stringToNumber(unmatched_identifiers), stringToNumber(ignored_identifiers)],
      backgroundColor: ['#7d0de5', '#d7c3ff', '#fec735', '#c1fe35'],
      borderColor: ['#7d0de5', '#d7c3ff', '#fec735', '#c1fe35'],
      borderWidth: 0.5,
      hoverBorderWidth: 0.5
    };

    const data = {
      datasets: [{
        labels: [translate('list.title.matched'), translate('list.title.Unmatched'), translate('list.title.ignored')],
        data: [stringToNumber(matched_identifiers), stringToNumber(unmatched_identifiers), stringToNumber(ignored_identifiers)],
        backgroundColor: ['#3f34b2', '#fec735', '#c1fe35'],
        borderColor: ['#3f34b2', '#fec735', '#c1fe35'],
        borderWidth: 0.5,
        hoverBorderWidth: 0.5
      },
      innerDataset,
      ],
    };

    const getOrCreateTooltip = (chart) => {
      let tooltipEl = chart.canvas.parentNode.querySelector('div');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';

        const table = document.createElement('table');
        table.style.margin = '0px';

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
      }

      return tooltipEl;
    };

    const externalTooltipHandler = (context) => {
      // Tooltip Element
      const { chart, tooltip } = context;
      const tooltipEl = getOrCreateTooltip(chart);

      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }

      // Set Text
      if (tooltip.body) {
        const bodyLines = tooltip.body.map((b) => { return b.lines; });
        let currentTitle;
        tooltip.dataPoints.map((e) => {
          e.dataset.data.map((x) => {
            currentTitle = e.dataset.labels[e.dataIndex];
            return x;
          });
          return e;
        });

        //const titleLines = tooltip.title || currentTitle || [];
        const titleLines = [currentTitle] || [];

        const tableHead = document.createElement('thead');

        titleLines.forEach((title) => {
          const tr = document.createElement('tr');
          tr.style.borderWidth = 0;

          const th = document.createElement('th');
          th.style.borderWidth = 0;
          const text = document.createTextNode(title);

          th.appendChild(text);
          tr.appendChild(th);
          tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');
        bodyLines.forEach((body, i) => {
          const colors = tooltip.labelColors[i];

          const span = document.createElement('span');
          span.style.background = colors.backgroundColor;
          span.style.borderColor = colors.borderColor;
          span.style.borderWidth = '2px';
          span.style.marginRight = '10px';
          span.style.height = '10px';
          span.style.width = '10px';
          span.style.display = 'inline-block';

          const tr = document.createElement('tr');
          tr.style.backgroundColor = 'inherit';
          tr.style.borderWidth = 0;

          const td = document.createElement('td');
          td.style.borderWidth = 0;

          const text = document.createTextNode(body);

          td.appendChild(span);
          td.appendChild(text);
          tr.appendChild(td);
          tableBody.appendChild(tr);
        });

        const tableRoot = tooltipEl.querySelector('table');

        tableRoot.style.display = 'inline-block';
        tableRoot.style.whiteSpace = 'nowrap';

        // Remove old children
        while (tableRoot.firstChild) {
          tableRoot.firstChild.remove();
        }

        // Add new children
        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
      }

      const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
      tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
      tooltipEl.style.font = tooltip.options.bodyFont.string;
      tooltipEl.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
    };

    const config = {
      type: 'pie',
      data,
      options: {
        layout: {
          padding: 0
        },
        interaction: {
          mode: 'nearest',
          intersect: false,
        },
        plugins: {
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: externalTooltipHandler,
            yalign: 'top'
          },
          legend: {
            display: false,
          },
        },
      },
    };

    const ctx = this.pieChart.getContext('2d');
    this.chart = new Chart(ctx, config);
  }

  render() {
    return (
      <div className="pie_chart_wrap">
        <canvas
          className="pie_chart"
          ref={(ref) => { this.pieChart = ref; }}
        />
      </div>
    );
  }
}

export default MultiSeriesPieChart;
